//ALERT/ADVISORY NOTIFICATION POSTS
//*******************************************************************
//*******************************************************************
//Importing Dependencies:
//external and package dependencies 
import React from 'react'
import { Link, graphql } from 'gatsby'
//component dependencies
import Heading from '../../components/heading'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import PageHeader from '../../components/PageHeader'
import TextBlock from '../../components/textblock'
import FeaturedImage from '../../components/featuredImage'
import FullWidthImage from '../../components/FullWidthImage'
import AlertHeader from '../../components/AlertHeader'
import AlertIcon from '../../images/alertIcon.png'
import Helmet from "react-helmet"
import '../../styles/blogLandingPage.css'
//*******************************************************************
//*******************************************************************
class AlertIndex extends React.Component {
    
    render() {
        
        const { data } = this.props
        
        const posts = data.allButterPost.edges
		
				const featuredPost = []
				
				for (var i = 0; i < 1; i++) {

		        featuredPost.push(posts[i]);

		    };
		        
		    const resultsTable = []
		    
		    for (var i = 1; i < 30; i++) {

		        resultsTable.push(posts[i]);

		    };
		        
		    const alertAdvisory = data.alerts_advisories.edges
				
				const sidebarContent = data.index.edges

        return (

            <div>
            
               	<Helmet>
					 
                    <title>NJCCIC Alerts and Advisories</title>
                    <meta name="description" content="Frequently released NJCCIC alerts and advisories on current threats"/>
					 
                </Helmet>
				
                <Heading/>

                <Navbar/>
            
                {alertAdvisory.map(({ node: { page_title, image, introductory_text} }) => (
                
                    <div class="container-fluid">
                        
                        <div class="container containerWidth">
                            
                            <div class="row">
								
								<div class="col-sm-12 col-md-8">
									
									<PageHeader elementClass="pageHeader" title={page_title}/>
									
									<div class="row featuredPostBlock noBorder">
									
										<div class="col-sm-12 col-md-4">
											
											<FeaturedImage src={image}/>
										
										</div>
										
										{featuredPost.map(({ node }) => {

										const postTitle = node.seo_title || node.slug

										const tag = node.tags

										return (

											<div class="col-sm-12 col-md-8 articleFeature featuredContent" key={node.slug}>

												<h2 class="featuredSectionHeader">Latest Content</h2>

												<h3 class="header leftHeader clickableHeader postHeader articleName"><Link to={`/alerts-advisories/${node.slug}`}>{postTitle}</Link></h3>

												{tag.map(({ name }) => (

													<p class="postDate">{node.date} | {name}</p>

												))}

												<p>{node.summary}</p>

												<p class="fontWeight"><Link to={`/alerts-advisories/${node.slug}`}>CONTINUE READING ></Link></p>       

											</div>

										)

									})}
									
									</div>
									
									<div class="row mainContentBlock">
										
										{resultsTable.map(({ node }) => {

											const postTitle = node.seo_title || node.slug

											const tag = node.tags

											return (

												<div class="container-fluid" key={node.slug}>

													<div class="row" id="alertsList">

														<div class="container containerWidth">

															<div class="col-12 alertBlock">

																<div class="col-12 iconHeading">

																	<h2 class="header leftHeader clickableHeader postHeader articleName"><Link to={`/alerts-advisories/${node.slug}`}>{postTitle}</Link></h2>
																	
																	{tag.map(({ name }) => (

																		<p class="postDate">{node.date} | {name}</p>

																	))}

																</div>

																<p>{node.summary}</p>
																
																<p class="fontWeight"><Link to={`/alerts-advisories/${node.slug}`}>CONTINUE READING ></Link></p>

															</div>

														</div>

													</div>                        

												</div>

											)

										})}	
										
									</div>
								
								</div>
								
								{sidebarContent.map(( {node: {sidebar_membership_image, resource_links, carousel_content} }) => (
								
								<div class="col-md-4 mb-4">
							
									<section class="sidebarSection">

										<form class="text-center border border-light" id="sidebarForm">

											<FullWidthImage id="sidebarBanner" src={sidebar_membership_image}/>
											<p class="h4 text-center sidebarHeader">Join & Subscribe</p>
											<p class="sidebarText">Never miss an update! Sign up for our no cost membership today to receive important cyber alerts and more delivered straight to your inbox.</p>
											<p class="text-center">
												<a href="/members/" target="_blank" class="btn btn-outline-info sidebarButton" role="button" >Sign Up</a>
											</p>
										</form>	

									</section>

									<section class="text-center sidebarSection">

										<p class="mb-4 h4 sidebarHeader" id="sidebarSecondHeader">Featured Content</p>

										<ul class="list-group list-group-flush">
											
												{carousel_content.map(carousel => (
													<li class="list-group-item text-truncate featuredLink sidebarText"><a href={carousel.url}>{carousel.caption}</a></li>
												))}

										</ul>

									</section>
										
								</div>
									
								))}
                                
                            </div>
                            
                        </div>
            
                    </div>
        
                ))}

                <Footer/>

            </div>
            
        )
        
    }
    
}

export default AlertIndex
//*******************************************************************
//*******************************************************************
export const pageQuery = graphql`
 {
  allButterPost(filter: {categories: {elemMatch: {name: {eq: "Alert-Advisory"}}}}) {
    edges {
      node {
        id
        seo_title
        meta_description
        slug
        categories {
          name
          slug
        }
        tags {
          name
          slug
        }
        date
        author {
          first_name
          last_name
          email
          slug
          bio
          title
          linkedin_url
          facebook_url
          instagram_url
          pinterest_url
          twitter_handle
          profile_image
        }
        summary
        body
        featured_image
      }
    }
  }
  alerts_advisories: allButterPage(filter: {slug: {eq: "alerts-advisories"}}) {
    edges {
      node {
        seo_title
        page_title
        introductory_text
        image
        image_alt_text
      }
    }
  }
	index: allButterPage(filter: {slug: {eq: "index"}}) {
    edges {
      node {
        carousel_content {
          caption
          url
        }
		sidebar_membership_image
      }
    }
  }
}
`